import __ from "web/Layout/Translations";

import classes from "./activeFormSubmitButton.scss";

const CheckoutSubscriptionActiveFormSubmitButton = () => {
  return (
    <div className={classes.buttons}>
      <button className={classes.submit} type="submit">
        {__("Zapisz i zamknij")}
      </button>
    </div>
  );
};

export default CheckoutSubscriptionActiveFormSubmitButton;
